import { RootState } from '../root.reducers';
import { RadiusParserPassword, RadiusParserPasswordsUIState } from './radiusParserPassword.types';

export const getRadiusParserPassword = (state: RootState): RadiusParserPassword | undefined =>
  state.radiusParserPassword.single;

export const isRadiusParserPasswordLoading = (state: RootState): boolean =>
  state.radiusParserPassword.ui.isLoading;

export const getRadiusParserPasswordsUIState = (state: RootState): RadiusParserPasswordsUIState =>
  state.radiusParserPassword.ui;
